import { render, staticRenderFns } from "./TaskPager.vue?vue&type=template&id=501e2cec&scoped=true"
import script from "./TaskPager.vue?vue&type=script&lang=js"
export * from "./TaskPager.vue?vue&type=script&lang=js"
import style0 from "./TaskPager.vue?vue&type=style&index=0&id=501e2cec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501e2cec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('501e2cec')) {
      api.createRecord('501e2cec', component.options)
    } else {
      api.reload('501e2cec', component.options)
    }
    module.hot.accept("./TaskPager.vue?vue&type=template&id=501e2cec&scoped=true", function () {
      api.rerender('501e2cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Task/TaskPager.vue"
export default component.exports